import React from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Clock, ArrowRight, Users } from "lucide-react";
import { PageHero } from "./Universita";

// Static upcoming events – update with real dates as needed
const EVENTS = [
  {
    title: "Open Day Polo Profili",
    date: "15 Marzo 2026",
    time: "16:00 - 19:00",
    location: "Via Forlanini 18, Sassari",
    desc: "Visita il polo, conosci il tutor e scopri tutti i corsi di laurea online di Pegaso, Mercatorum e San Raffaele. Aperitivo finale offerto.",
    tag: "In presenza",
    color: "bg-emerald-100 text-emerald-900",
  },
  {
    title: "Webinar: Come scegliere l'università telematica",
    date: "22 Marzo 2026",
    time: "18:00 - 19:00",
    location: "Online (Zoom)",
    desc: "Webinar gratuito di 60 minuti per orientarsi tra le 3 università. Confronto piani di studio, costi e tempi.",
    tag: "Online",
    color: "bg-violet-100 text-violet-900",
  },
  {
    title: "Orientamento individuale 1-to-1",
    date: "Tutto l'anno",
    time: "Su appuntamento",
    location: "Sassari o WhatsApp",
    desc: "Sessione gratuita di 30 minuti con un tutor del polo. Analizziamo i tuoi obiettivi e ti suggeriamo il percorso giusto.",
    tag: "Continuo",
    color: "bg-amber-100 text-amber-900",
  },
];

export default function Eventi() {
  return (
    <div data-testid="page-eventi">
      <PageHero
        eyebrow="Eventi & Open Day"
        title="Vieni a trovarci."
        sub="Open Day, webinar e orientamento individuale: tante occasioni per conoscere il Polo ECP Profili prima di iscriverti."
      />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 space-y-5">
          {EVENTS.map((e, i) => (
            <div key={i} className="lift-card rounded-3xl bg-brand-surface border border-brand-line p-6 lg:p-8 grid md:grid-cols-12 gap-6 items-center" data-testid={`event-${i}`}>
              <div className="md:col-span-3 text-center md:text-left">
                <div className={`inline-block px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${e.color}`}>
                  {e.tag}
                </div>
                <div className="font-heading font-extrabold text-2xl text-brand-navy mt-3">{e.date}</div>
                <div className="text-brand-muted text-sm inline-flex items-center gap-1.5 mt-1">
                  <Clock className="w-3.5 h-3.5" /> {e.time}
                </div>
                <div className="text-brand-muted text-sm inline-flex items-center gap-1.5 mt-1">
                  <MapPin className="w-3.5 h-3.5" /> {e.location}
                </div>
              </div>
              <div className="md:col-span-7">
                <h3 className="font-heading font-extrabold text-xl lg:text-2xl text-brand-navy">{e.title}</h3>
                <p className="text-brand-muted mt-2 leading-relaxed">{e.desc}</p>
              </div>
              <div className="md:col-span-2 flex md:justify-end">
                <Link to="/contatti" className="btn-primary text-sm" data-testid={`event-cta-${i}`}>
                  Prenota <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-brand-surface">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <Users className="w-10 h-10 text-brand-emerald mx-auto" />
          <h2 className="font-heading font-extrabold text-2xl sm:text-3xl text-brand-navy mt-4">
            Non puoi venire alle date in calendario?
          </h2>
          <p className="text-brand-muted mt-3 max-w-2xl mx-auto">
            Nessun problema. Scrivici via WhatsApp o compila il form: fissiamo un appuntamento personalizzato, in sede o online, secondo la tua disponibilità.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <a href="https://wa.me/393465726648" target="_blank" rel="noreferrer" className="btn-secondary" data-testid="eventi-whatsapp">
              WhatsApp
            </a>
            <Link to="/contatti" className="btn-primary" data-testid="eventi-contatti">
              Prenota appuntamento <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
